<template>
  <transition name="animation-briefcase-fade">
    <div class="block" v-if="isOpen" @click.self="close()">
      <ButtonClose class="block__close" @click="close()"/>
      <div class="block__widget">
        <WidgetModule />
      </div>
    </div>
  </transition>
</template>

<script setup>
  import { useBriefcaseDropdown } from '@/Groups/Briefcase/private/imports/toggleDropdown';
  //--------------------------
  import ButtonClose from '@/Groups/Briefcase/private/ui/ButtonClose/ButtonClose.vue';
  import WidgetModule from '@/Groups/Briefcase/private/core/WidgetModule/WidgetModule.vue';
  //--------------------------
  const { isOpen, close } = useBriefcaseDropdown();
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>